import React from 'react'
import "../../CSS/Blog/Nodejs.css"
import FooTer from "../footer"
export default function HTMLnode() {

    return (
        <div id='mainNode'>
            <h1 id="start">Raw HTML Render In Node JS Without Useing Any Template Engine</h1>
            <hr />
            <h1 className="hd">In This Video How We Can Render NodeJS Raw HTML Without Any Template Engine</h1>
            <div className="phishing-yt">
                <iframe id="yt" src="https://www.youtube.com/embed/BlBN8k4bzQI" title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen></iframe>
            </div>
            <div className="yt-visit">
                <h1 id="sub">
                    If You Guys Injoy My Video So Visit My Youtube Channel:
                </h1>
                <a id="cd" rel="noreferrer" href="https://www.youtube.com/channel/UClkomV-p7Ul_d4-Ye5uOvYg" target="_blank"><button>Code
                    Arindam</button></a>
            </div>
            <p className="ans">
                In This Video Using: <br />
                <br />
                1) HTML<br />
                2) Node JS<br />
                3) JAVASCRIPT (JS)<br />
                4) Node JS- Express Module <br />
                5) Router Express <br />
            </p>
            <h2 className="q">
                Node JS HTML rendering mean?
            </h2>
            <p className="ans">
                In NodeJS everytype of file run need a template enigine like PUG,EJX etc.
            </p>
            <h2 className="q">
                How This Video Help Out?
            </h2>
            <p className="ans">
                In This video we are using HTML render template without any types of Template engine like pug, ejs or anything
                else.
                Also we are using here post request and get request.I think This Video will helpfull for everyone cause this
                type of video will help you guys.
            </p>
            <h2 className="q">
                :: Look At The Code Of Rendering Template ::
            </h2>
            <div className="code">
                <p className="as">
                    const express = require("express"); <br />
                    const path = require("path"); <br />
                    const router =express.Router(); <br />
                    const app = express(); <br />
                    const port = 80; <br />
                    <br />
                    <br />
                    EXPRESS SPECIFIC STUFF <br />
                    router.use('/static', express.static('static')) // For serving static files <br />
                    router.use(express.urlencoded()) <br />
                    <br />
                    ENDPOINTS <br />
                    router.get('/',function(req,res)<br />
                    res-status(200) <br />
                    res.sendFile(path.join(__dirname+'/Template/index.html')); <br />
                    ); <br />
                    app.use(router); <br />
                    <br />
                    START THE SERVER <br />
                    app.listen(port, () = <br />
                    <span>console</span>log(`Server running at http://port`); <br />
                    <br />
                </p>
            </div>
            <h1 className="last">
                So Hope You Guys Injoy This Video And So Be Carefull And Stay Helthy And Have A Great Day...
            </h1>
            <FooTer />
        </div>
    )
}
